<template>
  <q-dialog v-model="model">
    <q-card class="column fit" style="width: 700px; max-width: 80vw">
      <q-toolbar>
        <q-toolbar-title>
          {{ title || 'File Preview' }}
        </q-toolbar-title>

        <q-btn dense flat icon="close" v-close-popup />
      </q-toolbar>

      <q-card-section class="q-pa-none col">
        <iframe v-if="iframeUrl" :src="iframeUrl" style="width: 100%; height: 100%; border: none" />
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
const model = defineModel<boolean>({ default: false })

defineProps<{
  title?: string
  iframeUrl: string | null
}>()
</script>

<style scoped lang="sass"></style>
